import { ColumnsConverter } from './ColumnsConverter';
import { convertSectionProperties } from './SectionPropertiesServerModel';
import { ContentSectionHelper } from '../content/contentBuilder/ContentSection';
export const ContentSectionConverter = {
    convertServerModel: (sectionServer) => {
        const conversionResults = ColumnsConverter.convertToDomainModel(sectionServer.columns);
        const section = ContentSectionHelper.build(sectionServer.id, sectionServer.columnLayout, conversionResults.columnIds, convertSectionProperties(sectionServer.properties));
        return {
            sectionId: sectionServer.id,
            fragments: [section, ...conversionResults.fragments],
        };
    },
    covertToServerModel: (section, content) => {
        return {
            id: section._id,
            columnLayout: section.value.columnLayout,
            columns: section.value.columns.map((columnId) => {
                const column = content.fragmentsById.get(columnId);
                return ColumnsConverter.convertToServerModel(column, content);
            }),
            properties: {
                backgroundColor: section.value.properties.backgroundColor,
                paddingTop: section.value.properties.paddingTop,
                paddingBottom: section.value.properties.paddingBottom,
                displayDelayInSeconds: section.value.properties.displayDelayInSeconds,
                maxWidth: section.value.properties.maxWidth,
                verticalAlignment: section.value.properties.verticalAlignment,
            },
        };
    },
};
